export class OrderMembershipUpdateRequestModel {
  constructor(public cardNumber: string, public feeId: string) {
  }
}
